import type { FormItemType, Language } from '@faceup/utils'
import { Fragment, type ReactNode } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../__generated__'
import { useFormItemsAnswers } from '../hooks'

export type Attachment = {
  id: string
  name: string
  url: string
  mimetype: string
}

export type FormItemAnswer = {
  id: string
  label: string
  value: string
  type: FormItemType
  // Required for redaction
  formItemId: string
  attachments?: Attachment[]
}

type FormItemsAnswersProps = {
  companyReport: FragmentType<typeof fragments.FormItemsAnswers_case>
  renderFormItemAnswer: (props: FormItemAnswer) => ReactNode
  defaultLanguage?: Language
}

const fragments = {
  FormItemsAnswers_case: graphql(`
    fragment FormItemsAnswers_case on CaseInterface {
      id
      answers {
        ...useFormItemsAnswers_formItemAnswer
      }
    }
  `),
}

export const FormItemsAnswers = (props: FormItemsAnswersProps) => {
  const { renderFormItemAnswer, companyReport: _companyReport, defaultLanguage } = props
  const companyReport = getFragmentData(fragments.FormItemsAnswers_case, _companyReport)
  const getFormItemsAnswers = useFormItemsAnswers()

  return (
    <>
      {getFormItemsAnswers(companyReport.answers, defaultLanguage).map(answer => (
        <Fragment key={answer.id}>{renderFormItemAnswer(answer)}</Fragment>
      ))}
    </>
  )
}
